/**
 * PageHeader
 * Consistent page header with title, subtitle and optional action buttons.
 */

import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode; // action buttons / filters
  className?: string;
}

export function PageHeader({ title, subtitle, children, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between', className)}>
      <div>
        <h1 className="text-2xl font-light text-content-primary uppercase tracking-[2px]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-1 text-sm font-light text-content-secondary">
            {subtitle}
          </p>
        )}
      </div>
      {children && (
        <div className="flex items-center gap-2 shrink-0">{children}</div>
      )}
    </div>
  );
}
